import { I18nType } from '@/ui/types/i18n.types';

export default function useProfileEditTexts(i18n: I18nType) {
  const gamertagLabel = i18n.getText('ProfileEdit', 'labels', 'gamertag');
  const gamertagPlaceholder = i18n.getText('ProfileEdit', 'placeholders', 'gamertag');
  const gamertagHint = i18n.getText('ProfileEdit', 'hints', 'gamertag');

  const profilePicLabel = i18n.getText('ProfileEdit', 'labels', 'profilePic');
  const profilePicHint = i18n.getText('ProfileEdit', 'hints', 'profilePic');

  const profileCoverLabel = i18n.getText('ProfileEdit', 'labels', 'profileCover');
  const profileCoverHint = i18n.getText('ProfileEdit', 'hints', 'profileCover');

  const cancelLabel = i18n.getText('ProfileEdit', 'labels', 'cancel');
  const finishLabel = i18n.getText('ProfileEdit', 'labels', 'finish');

  return {
    gamertagLabel,
    gamertagHint,
    gamertagPlaceholder,
    cancelLabel,
    finishLabel,
    profilePicHint,
    profilePicLabel,
    profileCoverHint,
    profileCoverLabel,
  };
}
